import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Project } from 'app/interfaces/project.model';
import { Detail } from 'app/interfaces/detail.model';
import { DetailService } from 'app/modules/project/services/detail.service';

@Injectable()
export class DetailResolver implements Resolve<Detail> {

  constructor(private service: DetailService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Detail | Observable<Detail> | Promise<Detail> {
    return this.service.single(route.params.id);
  }

}
